import React from "react";
import {
	NavLink,
	Link
} from "react-router-dom";

import config from './../config.js';
import Aside from './common/aside.js';
import Projectgroup from './project_group.js';

import Modal from './../../components/modal.js';
import Loading from './../../components/loading.js';

import ProjectServiceIntro from './project_service_intro.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);


class Project extends React.Component {
	constructor(props) {
		super(props);
		let user = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}
		//console.log(props.match)
		this.state = {
			pathurl: props.match.url,
			id: props.match.params.projectid,
			data_type: props.match.params.type, //0 or archive
			page_title: '项目管理',
			page_subtitle: ' Project',
			user: user,
			project: {
				id: "",
				user_id: "",
				company_id: "",
				name: "",
				description: "",
				level: "",
				share: "",
				status: ""
			},
			creator: {
				id: "",
				company_id: "",
				username: "",
				email: "",
				realname: "",
				telephone: "",
				date_login: "",
				date_created: "",
				title: "",
				office: "",
				address: ""
			},
			loading: false,
			ismodal: false,
			modaltitle: '',
			groupname: '',
			groupid: 0,
			updatedgroup: true,
			search: '',
			groups: []
		};

		document.title = this.state.page_title + this.state.page_subtitle;

		this.modalClose = this.modalClose.bind(this);
		this.modalSubmit = this.modalSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.goback = this.goback.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}


	componentDidMount() {
		this.getProject();
		this.onInitial();
	}


	componentWillReceiveProps(nextProps) {
		const self = this;
		let data_type = nextProps.match.params.type;
		//console.log(nextProps);
		self.setState({
			data_type: data_type
		});

		self.onInitial();
	}



	onInitial() {
		const me = this;
		//if(me.state.isrequest===false) return;
		let data_type = this.state.data_type;
		const postdata = {
			search: me.state.search,
			userid: me.state.user.id,
			projectid: me.state.id,
			data_type: data_type,
			Authorization: localStorage.token,
			request: 'grouplist'
		};
		me.setState({
			loading: true
		});
		let {
			all_subject_prototype
		} = me.state;
		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					let groups = json.data;
					groups.map(function (g, i) {
						g.showsubjects = true;
						g.checked = false;
						g.checkedsubject = 0;
						g.prototypes = [];
						if (g.subjects !== 'undefined' && g.subjects.total) {
							g.subjects.data.map((item, i) => {
								item.showfiles = false;
								item.checked = false;
								if (typeof (item.head) !== 'undefined' && item.head !== false && item.head.length > 0) {
									item.head.map((t, n) => {
										if (typeof (t.files) !== 'undefined' && t.files.length) {
											t.files.map((f, m) => {
												f.checked = false;
											})
										}
									});
								}
								if (item.modality === 'MR' && item.series.length) {
									item.series.forEach(iseries => {
										if (!g.prototypes.includes(iseries)) g.prototypes.push(iseries);
									})
								}



							});
						}
					});
					//groups = Object.assign(me.state.groups, groups)
					me.setState({
						groups: groups
					});
				} else {
					me.setState({
						groups: []
					})
				}
				me.setState({
					loading: false
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	}



	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}


	getProject() {
		const me = this;

		let {
			id,
			project,
			creator,
			user
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: id,
			Authorization: localStorage.token,
			request: 'project'
		};
		fetch(config.host + '/project/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					const data = json.data;
					me.setState({
						project: Object.assign(project, data.project),
						creator: Object.assign(creator, data.creator),
						page_title: data.project.name
					}); //Object.assign({},data)
					localStorage.current_project = JSON.stringify({
						project: project,
						creator: creator
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}



	handleInputChange(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		me.setState({
			[name]: value,
			updatedgroup: false
		})

	}


	modalClose() {
		this.setState({
			ismodal: false,
			loading: false
		})
	}

	trim(str) {
		return str.replace(/(^\s*)|(\s*$)/g, "");
	}

	modalSubmit() {
		const me = this;
		const {
			groupname
		} = me.state;
		if (me.trim(groupname) === '') {
			me.notify('分组名称不能为空');
			return;
		}
		me.postModal();
	}


	postModal() {
		const me = this;
		let {
			user,
			id,
			groupname,
			groupid,
			data_type
		} = me.state;
		const postdata = {
			userid: user.id,
			company_id: user.company_id,
			projectid: id,
			groupid: groupid,
			groupname: groupname,
			Authorization: localStorage.token,
			request: 'groupedit'
		};

		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(response);
				if (json.status === 1) {
					me.onInitial(data_type);
					me.setState({
						loading: false,
						ismodal: false
					});
					me.notify(json.message);
					return;
				}
				me.setState({
					loading: false,
					updatedgroup: true,
					ismodal: false
				});

				me.notify(json.message);
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	modalGroup(id) {
		const me = this;
		if (id === 0) {
			me.setState({
				ismodal: true,
				modaltitle: '创建分组'
			})
		} else {
			me.setState({
				ismodal: true,
				modaltitle: '编辑分组'
			})

		}
	}

	goback() {
		this.props.history.goBack(1);
	}


	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		const me = this;
		me.onInitial(me.state.data_type);
		return;
	}

	onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.handleSubmit();
		}
	}


	render() {
		const {
			data_type
		} = this.state;
		return (
			<div className="row">
				<Loading display={this.state.loading} classtype="" />
				<div className="col-10">
					<nav className="clearfix">
						<Link className="btn btn-sm  btn-outline-secondary mx-1 animated fadeInLeft" to={`/console/myprojects`}><strong><i className="fa fa-chevron-left"></i> 我的项目</strong></Link>

						<div className="float-right animated fadeInLeft">
							<button type="button" className="btn btn-sm btn-danger" onClick={() => { this.modalGroup(0) }}>创建分组</button>
						</div>
						<div className="btn-group  btn-group-sm float-right mr-2 animated fadeInRight" role="group" >
							<NavLink className="btn btn-sm  btn-outline-secondary px-3" exact to={`/console/myprojects/project/${this.state.id}/0`} activeClassName="btn-primary-secondary">影像</NavLink>
							<NavLink className="btn btn-sm btn-outline-secondary px-3" exact to={`/console/myprojects/project/${this.state.id}/archive`} activeClassName="btn-primary-secondary">其它</NavLink>
							<NavLink className="btn btn-sm btn-outline-secondary px-3" exact to={`/console/myprojects/project/${this.state.id}/service`} activeClassName="btn-primary-secondary">服务列表</NavLink>
						</div>
					</nav>
					<div className="mt-3">
						<div className="clearfix">
							<h5 className="float-left  mr-1" title={this.state.project.description}> {this.state.project.name} </h5>
							<small className="text-muted float-left pt-1"> 创建者: {this.state.creator.realname || this.state.creator.email} {this.state.creator.title} {this.state.creator.address} {this.state.creator.office}</small>
							<form className="form-inline float-right" onSubmit={this.handleSubmit}>
								<div className="form-group">
									<input type="search" name="search" className="form-control form-control-sm" placeholder="受试者编号、年龄、性别等" onChange={this.handleInputChange} onBlur={this.handleSubmit} value={this.state.search} style={{ 'minWidth': '200px' }} />
								</div>
								<button type="submit" className="btn btn-dark btn-sm">搜索</button>
							</form>
						</div>
						{/*
			data_type !== 'service' && <Projectgroup project={{id:this.state.id,data_type:data_type,project_name:this.state.project.name,isrequest:this.state.updatedgroup,pathurl:this.state.pathurl,search:this.state.search}} />
							*/}
						{
							data_type !== 'service' && <Projectgroup project={{ id: this.state.id, data_type: data_type, project_name: this.state.project.name, isrequest: this.state.updatedgroup, pathurl: this.state.pathurl, groups: this.state.groups }} onInitial={this.onInitial.bind(this)} />
						}
						{
							data_type === 'service' && <ProjectServiceIntro project={{ id: this.state.id }} />
						}

					</div>
				</div>
				<div className="col-2  pl-0 pr-0">
					<Aside data={this.props.match.params} />
				</div>
				<Modal title={this.state.modaltitle} display={this.state.ismodal} close={this.modalClose} submit={this.modalSubmit}>
					<div className="form-group row">
						<label className="col-sm-2 col-form-label text-right">分组名称：</label>
						<div className="col-sm-10">
							<input type="text" className="form-control" placeholder="Group Name ..." name="groupname" value={this.state.groupname} onChange={this.handleInputChange} />
							<small className="form-text text-muted">分组用以管理受试者</small>
						</div>
					</div>
				</Modal>
			</div>
		)
	}

}

export default Project


// WEBPACK FOOTER //
// ./src/apps/console/project.js